var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"confirmation"}},[_c('ec-order-info',{attrs:{"order":_vm.order,"isNew":true},on:{"update:order":function($event){_vm.order=$event}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }